import {
  NLT_FILE_UPLOAD_DROPPED,
  NLT_FILE_UPLOAD_REMOVED,
  POST_DOCUMENTI_NLT_UPLOAD_V1,
} from '../../constants/ActionTypes'
import { isNltBrumbrum } from '../../utils/nltUtils'
import { createBasicCreator } from '../Buy'
import { fetchPostFileUpload } from '../buy/Documenti'

export const postDocumentiUploadV1 = (dispatch, getState) => {
  const { product } = getState()
  const uploadPath = isNltBrumbrum(product) ? '/nlt-brumbrum' : '/nlt'

  return dispatch(
    fetchPostFileUpload(POST_DOCUMENTI_NLT_UPLOAD_V1)({
      callback: POST_DOCUMENTI_NLT_UPLOAD_V1,
      dropzone: getState().nlt.dropzone,
      errorMessage: POST_DOCUMENTI_NLT_UPLOAD_V1,
      id_ordine: getState().ordine.id_ordine,
      uploadPath,
    })
  )
}

export const nltFileUploadDropped = createBasicCreator(NLT_FILE_UPLOAD_DROPPED)
export const nltFileUploadRemoved = createBasicCreator(NLT_FILE_UPLOAD_REMOVED)
